import {
    Component,
    OnInit,
    ViewChild,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ActionButtonComponent } from "@components/action-button/action-button.component";
import { ButtonComponent } from "@components/button/button.component";
import { HeaderComponent } from "@components/header/header.component";
import { InputComponent } from "@components/input/input.component";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { take } from "rxjs/operators";
import { ModalSettings } from "~app/common/components/modal/modal-models";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { ConfirmDialogResponse } from "~app/common/models/constants";
import { IVKNamedSearchFilter } from "../../../models/kontrakt-search-filter-model";
import { AnbudKontraktSearchService } from "../../../services/anbud-kontrakt-search.service";
import { KontraktSearchMinaFilterService } from "../kontrakt-search-mina-filter.service";

@Component({
    selector: "rask-kontrakt-save-filter",
    templateUrl: "./kontrakt-save-filter.component.html",
    styleUrls: ["./kontrakt-save-filter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        ActionButtonComponent,
        NgbTooltip,
        InputComponent,
        FormsModule,
        ButtonComponent
    ]
})
export class KontraktSaveFilterComponent implements OnInit {
    errors: string[];
    filter: IVKNamedSearchFilter;
    @ViewChild("tooltip") tooltip: NgbTooltip;

    private readonly anbudKontraktSearchService = inject(AnbudKontraktSearchService);
    private readonly kontraktSearchMinaFilterService = inject(KontraktSearchMinaFilterService);
    private readonly modalService = inject(RaskModalService);

    abort() {
        this.close();
    }

    close() {
        this.reset();
        this.tooltip.close();
    }

    ngOnInit(): void {
        this.reset();
    }

    onClose() {
        this.reset();
    }

    trySave() {
        if (!this.filter.namn) {
            this.errors = ["Ange namn"];
            return;
        }
        if (!this.kontraktSearchMinaFilterService.nameIsUnique(this.filter)) {
            const ejUniktNamn = this.filter.namn;
            this.modalService.confirm(new ModalSettings("Det finns redan en sökning med detta namn", `Vill du skriva över "${ejUniktNamn}"?`))
                .pipe(take(1))
                .subscribe((ok: string) => {
                    if (ok === ConfirmDialogResponse.cancel) {
                        return;
                    }
                    this.filter.filter = this.anbudKontraktSearchService.searchFilter$.getValue();
                    this.kontraktSearchMinaFilterService.updateSearchFilterByNamn(this.filter);
                    this.close();
                });
        } else {
            if (this.kontraktSearchMinaFilterService.saveLimitReached()) {
                this.errors = ["Det går ej att spara fler sökningar. Du kan ersätta eller ta bort en sökning"];
                return;
            }

            this.filter.filter = this.anbudKontraktSearchService.searchFilter$.getValue();

            this.kontraktSearchMinaFilterService.saveSearchFilter(this.filter);
            this.close();
        }
    }

    private reset() {
        this.filter = { namn: "" } as IVKNamedSearchFilter;
        this.errors = [];
    }
}
